module.exports = __webpack_public_path__ + "img/icon-calender.f9864a3b.svg";